import { combineReducers } from '@reduxjs/toolkit';
import openPtos from './openOrder';
import searchPtos from './searchOrder';
import originators from './originators';
import recipients from './recipients';
import locations from './locations';
import ptoNumbers from './orderNumbers';
import referenceIds from './referenceIds';
import products from './products';
import affiliates from './affiliates';
import originatorLocations from './originatorLocations';
import originatorLocationProducts from './originatorLocationProducts';
import originatorLocationProductReidVaporPressures from './originatorLocationProductReidVaporPressures';
import originatorLocationProductOrigins from './originatorLocationProductOrigins';
import originatorLocationProductBalances from './originatorLocationProductBalances';
import reidVaporPressures from './reidVaporPressures';
import ptoDetails from './orderDetails';
import editPtoDetails from './editOrderDetails';
import acceptPto from './acceptOrder';
import rejectPto from './rejectOrder';
import cancelPto from './cancelOrder';
import searchPtoFilters from './searchFilters';
import createPto from './createOrder';
import ptoDrawer from './orderDrawer';
import productBalance from './productBalance';

export default combineReducers({
  acceptPto,
  affiliates,
  cancelPto,
  createPto,
  editPtoDetails,
  locations,
  openPtos,
  originatorLocationProductBalances,
  originatorLocationProductOrigins,
  originatorLocationProductReidVaporPressures,
  originatorLocationProducts,
  originatorLocations,
  originators,
  productBalance,
  products,
  ptoDetails,
  ptoDrawer,
  ptoNumbers,
  recipients,
  referenceIds,
  reidVaporPressures,
  rejectPto,
  searchPtoFilters,
  searchPtos,
});
